import React from 'react';
import './index.css';

const videoActive = () => {
  return (
    <div className='videoActive'>

    </div>
  );
};

export default videoActive;
